import React from 'react';
import Title from '../../../components/PublishedForm/Text/Text';
import List from '../../../components/PublishedForm/List/List';
import ShortText from '../../../components/PublishedForm/ShortText/ShortText';
import Image from '../../../components/PublishedForm/Image/Image';
import Output from '../../../components/PublishedForm/Output/Output';
import Input from '../../../components/PublishedForm/Input/Input';
import { Box, Button } from '@mui/material';

const NodesPreview = ({
  nd,
  inputs,
  outputs,
  setInputs,
  setOutputs,
  onSubmit,
}: any) => {
  const { type, data, position, id } = nd;
  const { label } = data;

  if (type === 'title') {
    return (
      <Title
        key={id}
        data={{
          label: data?.title || '',
          fullData: data,
          style: {
            maxWidth: nd?.width ? nd?.width - 32 : 'auto',
            // position: 'absolute',
            width: '100%',

            backgroundColor: 'white',
            // left: position.x,
            // top: position.y,
          },
        }}
      />
    );
  }

  if (type === 'listNode') {
    return (
      <List
        key={id}
        input={inputs}
        setInputs={setInputs}
        data={{
          label: data?.title || '',
          fullData: data,
          question: data?.question || '',
          options: data?.options || [],
          type: data?.type || 'dropdown',
          width: '100%',

          style: {
            maxWidth: nd?.width ? nd?.width - 32 : 'auto',
            // position: 'absolute',
            backgroundColor: 'white',

            // left: position.x,
            // top: position.y,
          },
        }}
      />
    );
  }

  if (type === 'shortText') {
    return (
      <ShortText
        key={id}
        data={{
          label: data?.title || 'Name (Optional)',
          subtitle: data?.subtitle,
          text: data?.text,
          width: '100%',
          fullData: data,
          style: {
            maxWidth: nd?.width ? nd?.width - 32 : 'auto',
            // position: 'absolute',
            // backgroundColor: 'white',
            // left: position.x,
            // top: position.y,
          },
        }}
      />
    );
  }

  if (type === 'image') {
    return (
      <Image
        key={id}
        data={{
          label: data?.title,
          subtitle: data?.subtitle,
          fullData: data,
          width: '100%',
          url: data?.url || '',
          style: {
            maxWidth: nd?.width ? nd?.width - 32 : 'auto',
            // position: 'absolute',
            backgroundColor: 'white',
            // left: position.x,
            // top: position.y,
          },
        }}
      />
    );
  }

  if (type === 'outputDisplay') {
    return (
      <Output
        key={id}
        output={outputs?.find(
          (out: any) => out?.outputId === data?.selectedFlow,
        )}
        setOutputs={setOutputs}
        data={{
          label: data?.title || 'Name (Optional)',
          width: '100%',
          fullData: data,
          subtitle: data?.subtitle,
          style: {
            maxWidth: nd?.width ? nd?.width - 32 : 'auto',
            // position: 'absolute',

            // left: position.x,
            // top: position.y,
          },
        }}
      />
    );
  }

  if (type === 'inputDisplay') {
    return (
      <Input
        key={id}
        input={inputs}
        setInputs={setInputs}
        data={{
          label: data?.title || 'Name (Optional)',
          width: '100%',
          fullData: data,
          subtitle: data?.subtitle,
          style: {
            maxWidth: nd?.width ? nd?.width - 32 : 'auto',
            // position: 'absolute',
            backgroundColor: 'white',
            // left: position.x,
            // top: position.y,
          },
        }}
      />
    );
  }

  if (type === 'submit') {
    return (
      <Box>
        <Button onClick={onSubmit} variant="contained">
          Submit
        </Button>
      </Box>
    );
  }

  return (
    <Box
      key={id}
      sx={{
        // position: 'absolute',
        maxWidth: nd?.width ? nd?.width - 32 : 'auto',
        width: '100%',

        backgroundColor: 'white',
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '5px',
        mb: '16px',
        // left: position.x,
        // top: position.y,
      }}
    >
      {label}
    </Box>
  );
};
export default NodesPreview;
